import './utils/vh.utils.js';
import './utils/animate-on-view.utils';
import './utils/parallax-on-view.utils.js';
import './utils/safari.utils.js';

import './libs/cookiesconsent.js';

import './components/header.component.js';
import './components/uploadFile.component.js';
import './components/inputs.component.js';
import './components/project-meta-select.component.js';
import './components/meta-time-picker.component.js';
import './components/date.component.js';
import './components/checkout.component.js';
/*import './components/buttons.component.js';*/
import './components/cart.component.js';
import './components/products.component.js';
import './components/meta-select.component.js';

/*Sliders*/
import './components/swiper-testimonials.component.js';
import './components/swiper-recipes.component.js';
import './components/swiper-values.component.js';
import './components/swiper-products.component.js';
import './components/swiper-videos.component.js';
import './components/swiper-product.component.js';
import './components/swiper-feedback.component.js';
import './components/categories.component.js';
/*End Sliders*/

import './components/faq.component.js';
import './components/locations.component.js';
import './components/delivery.component.js';
import './components/authorization.component.js';
import './components/titles.component.js';
import './components/order-history.component.js';

import './libs/countUp.lib.js';
import './map-logic.js';

/*const scrollToTopElement = document.getElementById('scroll-to-top');
const followingCart = document.getElementsByClassName('following-cart')[0];

if (scrollToTopElement) {
  scrollToTopElement.addEventListener('click', function () {
    scrollIntoView(document.getElementById('map'));
  });

  if (!followingCart.classList.contains('sr-only')) {
    scrollToTopElement.classList.add('bottom-[90px]');
    followingCart.style.right = '4vw';
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      scrollToTopElement.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      scrollToTopElement.classList.add('opacity-0', 'pointer-events-none');
    }
  });
}*/

if(document.querySelector('#site') && document.querySelector('#site').classList.contains('full-container-type')) {
  document.querySelector('body').classList.add('site-full-container-type');
}
